import { GetAccountOrgsResponse } from '@atlassiansox/asc-stargate';

export type AccountOrg = GetAccountOrgsResponse[0];

export enum VortexStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

/**
 *
 * @param orgList List of account org information
 * @returns Record that maps Vortex Status to the respective number of orgs
 */
export function getOrgAdminVortexStatusCounts(
  orgList: GetAccountOrgsResponse
): Record<VortexStatus, number> {
  const orgCount = {
    [VortexStatus.ENABLED]: 0,
    [VortexStatus.DISABLED]: 0
  };

  orgList.forEach(({ isAdmin, vortexMode }) => {
    if (isAdmin && !!vortexMode) orgCount[vortexMode as VortexStatus]++;
  });

  return orgCount;
}
